<template>
  <div class="order-today-page">
    <div class="bd-container">
      <div class="block">
        <img :src="'/static/theme-green/images/order/ddgz.png'" class="tit" alt="">
        <div class="hd">
          <div class="search">
            <input type="text" v-model="orderNumber" placeholder="请输入订单编号">
            <span class="sbtn" @click="getOrderList()">查询</span>
          </div>
        </div>
        <div class="bd">
          <div class="list-block">
            <template v-for="osd in orderStatusData">
              <div class="litem" v-for="item in orderTypes" v-if="item.value==orderCurrentType">
                <div :class="['status', 'transition', {'active': orderInfo.OrderState==osd.value}]" @click="statusSwitch(osd.value, item)"><span><span v-text="osd.label"></span>（<span v-text="item.data&&item.data[osd.value]?item.data[osd.value].length:0"></span>个）</span><i :class="[{'i-arrow-right': showStatus!=osd.value||!(item.data&&item.data[osd.value]&&item.data[osd.value].length)}, {'i-arrow-down': showStatus==osd.value&&(item.data&&item.data[osd.value]&&item.data[osd.value].length)}]"></i></div>
                <div class="list" v-if="item.data&&item.data[osd.value]&&item.data[osd.value].length" v-show="showStatus==osd.value">
                  <div :class="['itm', 'transition', {'active': itm.OrderNo==orderInfo.OrderNo}, {'alarm-type-2': itm.DelayedTime>0||itm.Unnormal}]" v-for="(itm, index) in item.data[osd.value]" @click="orderSwitch(itm)">
                    <i class="i-ring" v-if="itm.DelayedTime>0||itm.Unnormal"></i>
                    <div class="itno" v-text="(index+1)+'、'+itm.OrderNo"></div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="box">
            <div class="item-box">
              <div class="tab">
                <span v-for="item in orderTypes" :class="[{'active': orderCurrentType==item.value}, 'transition']" v-text="item.label" @click="orderTabSwitch(item)"></span>
              </div>
              <div class="btn-box">
                <div class="bitm" style="display:none;"><i class="i-recall"></i><span>订单回溯</span></div>
                <router-link class="bitm" :to="{path: '/order/task-detail', query: {'oid': orderInfo.OrderNo}}">
                  <span>任务详情</span>
                </router-link>
              </div>
              <div class="detail">
                <div class="itm tit">订单详情</div>
                <div class="itm">
                  <span class="label">订单编号：</span>
                  <span class="value" v-text="orderInfo.OrderNo"></span>
                </div>
                <div class="itm">
                  <span class="label">来源单号：</span>
                  <span class="value" v-text="orderInfo.OrderSource"></span>
                </div>
                <div class="itm">
                  <span class="label">单据类型：</span>
                  <span class="value" v-for="item in orderTypes" v-if="orderInfo.OrderType==item.value" v-text="item.label"></span>
                </div>
              </div>
            </div>
            <div class="item-box">
              <div class="btit">订单历程</div>
              <div class="process">
                <div class="pitm">
                  <i :class="['i-order-create', {'finish': orderInfo.FinishProgress}]"></i>
                  <div class="info">
                    <div :class="['text', {'finish': orderInfo.FinishProgress}]">订单创建</div>
                    <div class="dt-box">
                      <div>
                        <span class="label">预计用时:</span>
                        <span class="value" v-text="(orderInfo.OrderCreateProcess?Math.round(orderInfo.OrderCreateProcess.ExpectExpenseTime*100)/100:0)+'min'"></span>
                      </div>
                      <div>
                        <span class="label">实际用时:</span>
                        <span class="value" v-text="(orderInfo.OrderCreateProcess?Math.round(orderInfo.OrderCreateProcess.ActualTime*100)/100:0)+'min'"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pitm line">
                  <em :style="{width: (orderInfo.FinishProgress?100:0)+'%'}"></em>
                </div>
                <div class="pitm">
                  <i :class="['i-device-send', {'finish': orderInfo.FinishProgress}]"></i>
                  <div class="info">
                    <div :class="['text', {'finish': orderInfo.FinishProgress}]">下发设备</div>
                    <div class="dt-box">
                      <div>
                        <span class="label">预计用时:</span>
                        <span class="value" v-text="(orderInfo.DeleveryEquiment?Math.round(orderInfo.DeleveryEquiment.ExpectExpenseTime*100)/100:0)+'min'"></span>
                      </div>
                      <div>
                        <span class="label">实际用时:</span>
                        <span class="value" v-text="(orderInfo.DeleveryEquiment?Math.round(orderInfo.DeleveryEquiment.ActualTime*100)/100:0)+'min'"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pitm line active">
                  <em :style="{width: (orderInfo.FinishProgress?orderInfo.FinishProgress:0)+'%'}"></em>
                  <div class="up-tips unnormal" v-if="orderInfo.UnNormal||orderInfo.DelayedTime>0">
                    <div style="margin-bottom: 2px!important;"><span v-text="orderInfo.FinishProgress?orderInfo.FinishProgress:0"></span>%</div>
                    <div>延时：<span v-text="Math.round(orderInfo.DelayedTime*100)/100"></span>min</div>
                  </div>
                  <div class="up-tips normal" v-else>
                    <div><span v-text="orderInfo.FinishProgress?orderInfo.FinishProgress:0"></span>%</div>
                  </div>
                  <!-- <div class="down-tips unnormal">正在入库</div> -->
                </div>
                <div class="pitm">
                  <i :class="['i-device-finish', {'finish': orderInfo.FinishProgress&&orderInfo.FinishProgress==100}]"></i>
                  <div class="info">
                    <div :class="['text', {'finish': orderInfo.FinishProgress&&orderInfo.FinishProgress==100}]">设备执行完成</div>
                    <div class="dt-box">
                      <div>
                        <span class="label">预计用时:</span>
                        <span class="value" v-text="(orderInfo.EquimentExcuteFinish?Math.round(orderInfo.EquimentExcuteFinish.ExpectExpenseTime*100)/100:0)+'min'"></span>
                      </div>
                      <div>
                        <span class="label">实际用时:</span>
                        <span class="value" v-text="(orderInfo.EquimentExcuteFinish?Math.round(orderInfo.EquimentExcuteFinish.ActualTime*100)/100:0)+'min'"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="pitm line">
                  <em :style="{width: (orderInfo.FinishProgress&&orderInfo.FinishProgress==100?100:0)+'%'}"></em>
                </div>
                <div class="pitm">
                  <i :class="['i-order-finish', {'finish': orderInfo.FinishProgress&&orderInfo.FinishProgress==100}]"></i>
                  <div class="info">
                    <div :class="['text', {'finish': orderInfo.FinishProgress&&orderInfo.FinishProgress==100}]">订单完成</div>
                    <div class="dt-box">
                      <div>
                        <span class="label">预计用时:</span>
                        <span class="value" v-text="(orderInfo.OrderFinishProcess?Math.round(orderInfo.OrderFinishProcess.ExpectExpenseTime*100)/100:0)+'min'"></span>
                      </div>
                      <div>
                        <span class="label">实际用时:</span>
                        <span class="value" v-text="(orderInfo.OrderFinishProcess?Math.round(orderInfo.OrderFinishProcess.ActualTime*100)/100:0)+'min'"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="item-box" style="margin-top: 30px;">
              <div class="btit">订单进度</div>
              <div class="process">
                <div class="percent-item">
                  <div class="tl">
                    计划数量：
                    <br><span v-text="(orderInfo.PlanCount?orderInfo.PlanCount:0)+'(箱)'"></span>
                  </div>
                  <div class="pg">
                    <div class="ing" :style="{'width': (orderInfo.FinishProgress?orderInfo.FinishProgress:0)+'%'}">
                      <img :src="'/static/theme-green/images/order/process-a.png'" alt="">
                    </div>
                    <div class="fn-info">
                      实际完成数量：<br>
                      <span v-text="(orderInfo.FinishedTaskCount?orderInfo.FinishedTaskCount:0)+'(箱)'"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block">
        <div class="chart-item">
          <img :src="'/static/theme-green/images/order/ddrwgk.png'" class="tit" alt="">
          <div class="chart-box">
            <v-chart :options="options_ddgk"/>
            <div class="text">
              <div class="list">
                <div><span class="label">总任务量：</span><span v-text="taskTotal"></span>个</div>
                <div v-for="(item, key) in ddgkList"><span class="label" v-text="ddgkLabel[key]+'：'"></span><span v-text="item"></span>个</div>
              </div>
            </div>
          </div>
        </div>
        <div class="chart-item">
          <img :src="'/static/theme-green/images/order/ycyj.png'" class="tit" alt="">
          <table>
            <thead>
              <tr>
                <!-- <th>异常等级</th> -->
                <th width="30%">延时时间（min）</th>
                <th>订单编号</th>
                <!-- <th>发现时间</th> -->
                <th width="15%">当前状态</th>
                <th width="30%">异常描述</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in ycyjList" :class="[{'ringing': item.Status=='报警中'}, {'dealing': item.Status=='处理中'}]">
                <!-- <td v-text="item.Level"></td> -->
                <td>
                  <span class="tdtxt" v-text="Math.round(item.DelayedTime*100)/100"></span>
                  <div class="full-box">
                    <span class="txt" v-text="Math.round(item.DelayedTime*100)/100"></span>
                  </div>
                </td>
                <td>
                  <span class="tdtxt" v-text="item.OrderNo"></span>
                  <div class="full-box">
                    <span class="txt" v-text="item.OrderNo"></span>
                  </div>
                </td>
                <!-- <td v-text="item.DiscoveryTime"></td> -->
                <td v-text="item.ErrorStatus==1?'报警中':'正常'"></td>
                <td>
                  <span class="tdtxt" v-text="item.ErrorDiscription"></span>
                  <div class="full-box" v-if="item.ErrorDiscription">
                    <span class="txt" v-text="item.ErrorDiscription"></span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="page-container">
            <v-pagination :total="totalCount" size="mini" :current-page='pageIndex' :display="pageSize" @pagechange="pageChange"></v-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts/lib/echarts'
import pagination from '@/components/widgets/Pagination'
export default{
  components: {
    'v-pagination': pagination,
  },
  props: ['theme'],
  data() {
    let orderTypes = [
      {
        value: 1,
        label: '出库订单',
      },
      {
        value: 2,
        label: '入库订单',
      },
      {
        value: 3,
        label: '盘点订单',
      },
      {
        value: 4,
        label: '其它订单'
      },
    ];
    let orderStatusData = [
      {
        'value': 3,
        'label': '已完成'
      },
      {
        'value': 2,
        'label': '执行中'
      },
      {
        'value': 1,
        'label': '待执行'
      },
    ];
    let todayTime = new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000; //今天0点时间戳秒
    return {
      date1: this.$formatDateTime(todayTime - 3600 * 24 * 30, "yyyy-MM-dd"),
      orderNumber: '',
      orderStatusData: orderStatusData,
      orderTypes: orderTypes,
      orderCurrentType: orderTypes[0].value,
      orderInfo: {},
      showStatus: 0,
      orderList: [],
      options_ddgk: {},
      ddgkList: {},
      ddgkLabel: {},
      taskTotal: 0,
      ycyjList: [],
      totalCount: 0,
      pageIndex: 1,
      pageSize: 6
    }
  },
  watch:{
    $route(to, from) {
      console.log('--route--', to, from);
      this.$initPage(this);
    },
  },
  mounted() {
    console.log('--mounted--')
    //定义全局方法
    window.gbfc_resetData = this.resetData;
    this.$initPage(this);
  },
  methods: {
    resetData() {
      //订单列表
      this.getOrderList();
      //订单概况
      this.getDdgkList();
      //异常预警
      this.getYcyjList();
    },
    orderTabSwitch(item, orderInfo) {
      this.orderCurrentType = item.value;
      if(orderInfo && orderInfo.OrderNo) {
        this.orderInfo = orderInfo;
      } else {
        if(item.data && item.data[3] && item.data[3][0]) {
          this.orderInfo = item.data[3][0];
        } else if(item.data && item.data[2] && item.data[2][0]) {
          this.orderInfo = item.data[2][0];
        } else if(item.data && item.data[1] && item.data[1][0]) {
          this.orderInfo = item.data[1][0];
        } else {
          this.orderInfo = {};
        }
      }
      this.showStatus = this.orderInfo.OrderState ? this.orderInfo.OrderState : 0;
    },
    orderSwitch(item) {
      this.orderInfo = item;
    },
    statusSwitch(status, item) {
      this.showStatus = this.showStatus != status ? status : 0;
    },
    getOrderList() {
      let self = this;
      //window.ApiHost1+'/static/data/Orders_Info.json'
      this.$handleRequest(window.ApiHost1+'/api/DataStatistical/Orders_Info', {

          "OrderNo": "",
          "Date": '2020-04-29',//this.date1,
          "WareHouseCode": window.PYKWareHouseCode,
      }, 'post', function(res) {  //success

        console.log("=============")
        console.log(res)
        let allList = res.retData.Rows;
        let idx = 0;
        let existed = false;
        let orderInfo = {};
        self.orderTypes.forEach( function(t, ti) {
          t.data = {};
          allList.forEach( function(l, li) {
            if(typeof(t.data[l.OrderState]) == 'undefined') {
              t.data[l.OrderState] = [];
            }
            l.FinishProgress = Math.round(l.FinishedTaskCount/l.PlanCount*1000)/10;
            if(l.OrderType == t.value) {
              t.data[l.OrderState].push(l);
              if(self.orderNumber && self.orderNumber == l.OrderNo) {
                idx = ti;
                existed = true;
                orderInfo = l;
              }
            }
          });
        });
        if(self.orderNumber && !existed) {
          self.$msgAlert.warning('没有相关订单！');
        } else {
          self.orderTabSwitch(self.orderTypes[idx], orderInfo);
        }
      }, function(res) {
        //fail
        console.log(55555555555)
      });
    },
    getDdgkList(){
      let self = this;
      this.ddgkLabel = {
        FinishedCount: "已完成",
        ExcutingCount: "执行中",
        ToExcuteCount: "待执行",
      }
      this.$handleRequest(window.ApiHost1+'/api/DataStatistical/TodayOrders_Count', {
        "WareHouseCode": window.PYKWareHouseCode,
        "Date": '2020-04-01',//this.$formatDateTime(null, 'yyyy-MM-dd'),
        "OrderNo": "",
      }, 'post', function(res) {  //success


        self.ddgkList = res.retData;
        self.setOptionsDdgk();
      }, function(res) {
        //fail
      });
    },
    setOptionsDdgk() {
      let colors = this.$charts.colors.style_2;
      let chartsConf = this.$charts[window.CurrentTheme];
      let sdata = [];
      let di = 0;
      let taskTotal = 0;
      for(let key in this.ddgkList) {
        let countVal = Math.floor(this.ddgkList[key] * 100) /100;
        taskTotal += countVal;
        let color1 = colors[di][0];
        let color2 = colors[di][1];


        //字体颜色
        let tmp = {
          value: countVal,
          name: (this.ddgkLabel[key] ? this.ddgkLabel[key] : key),
          label: {
            normal: {
              rich: {
                hr: {
                  borderColor: color2
                },
                per: {
                  color: "#fff"
                }
              }
            }
          },
          itemStyle:{
            normal:{
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {offset: 0, color: color1}, {offset: 1, color: color2}
              ])
            }
          }
        };
        sdata.push(tmp);
        di ++;
      }
      this.taskTotal = taskTotal;

      this.options_ddgk = {
        series: [
          {
            type:'pie',
            radius: ['38%', '55%'],
            avoidLabelOverlap: true,
            labelLine: {
              //length: 30,
              length2: 30
            },
            label: {
              normal: {
                  formatter: '{per|{d}%} \n{hr|}\n {b|{b}}',
                  backgroundColor: '#80D2B6',//'#061445',
                  padding: 15,
                  borderColor: '#0D7357',//'#5165b7',
                  borderWidth: 1,
                  rich: {
                    /*hr: {
                      //borderColor: '#fff',
                      width: '100%',
                      borderWidth: 0.5,
                      height: 0,
                    },*/
                    b: {
                      fontSize: 18,
                      color: "#fff",//'#fff',
                      //padding: [0, 0, 0, 0]
                    },
                    per: {
                      align: 'center',
                      fontSize: 20,
                      //padding: [0, 0, 0, 0]
                    }
                  }
              }
            },
            data: sdata
          }
        ]
      };
    },

    pageChange(pageIndex) {
      console.log('pageIndex', pageIndex);
      this.pageIndex = pageIndex;
      this.getYcyjList();
    },

//未执行
    getYcyjList() {
      let self = this;
      this.$handleRequest(window.ApiHost1+'/api/DataStatistical/Orders_Info', {
        "WareHouseCode": window.PYKWareHouseCode,
        "Date": '2020-04-01',//this.$formatDateTime(null, 'yyyy-MM-dd'),//默认为当天
      }, 'post', function(res) {  //success

        self.ycyjList = self.$dataPage(res.retData.UnnormalRows, self.pageIndex, self.pageSize);
        self.totalCount = res.retData.TotalCount ? res.retData.TotalCount : res.retData.UnnormalRows.length;
      }, function(res) {
        //fail
         console.log("999")
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/xiayan/order/TodayOrder.vue